import classNames from 'classnames';

const TabButton = ({
    handleTabClick,
    index,
    isActive,
    title,
    isPrimaryBgColorDark,
    trackingName,
}: {
    handleTabClick: (i: number) => void;
    index: number;
    isActive: boolean;
    title: string;
    isPrimaryBgColorDark: boolean;
    trackingName: string;
}) => {
    const htmlStrippedTitle = title.replace(/<.+>/g, ' ');
    return (
        <button
            onClick={() => handleTabClick(index)}
            data-wa-link={`${trackingName}: ${htmlStrippedTitle}`}
            className={classNames(
                'p-4 w-full h-full',
                'my-1 lg:my-0',
                isActive
                    ? `font-bold ${
                          isPrimaryBgColorDark
                              ? 'bg-surface-light text-primary-dark'
                              : 'bg-surface-primary-darker text-white'
                      }`
                    : `font-normal bg-transparent ${
                          isPrimaryBgColorDark ? 'text-white' : 'text-black'
                      }`
            )}
        >
            <h2
                className={classNames(
                    'font-poppins text-20 leading-28',
                    'flex items-center lg:justify-center text-left lg:text-center'
                )}
                dangerouslySetInnerHTML={{ __html: title }}
            ></h2>
        </button>
    );
};

export default TabButton;
